import pipeIconRaw from '../images/icons/pipe_circle.svg?raw';
import globalPipeIconRaw from '../images/icons/global_circle.svg?raw';
import systemIconRaw from '../images/icons/system_circle.svg?raw';

// The SVG source files use #FF00FF as a placeholder color.
// Replace it at runtime to produce colored icons without React or ReactDOMServer,
// so this module is safe to import from Web Worker bundles as well as the main thread.
const PLACEHOLDER = /#FF00FF/gi;

function coloredSvgDataUrl(raw: string, color: string): string {
  return `data:image/svg+xml;utf8,${encodeURIComponent(raw.replace(PLACEHOLDER, color))}`;
}

export const pipeIcon = (color: string) => coloredSvgDataUrl(pipeIconRaw, color);
export const globalPipeIcon = (color: string) => coloredSvgDataUrl(globalPipeIconRaw, color);
export const systemIcon = (color: string) => coloredSvgDataUrl(systemIconRaw, color);
export const systemSelectedIcon = systemIcon('rgb(0, 129, 193)');
